import { render, staticRenderFns } from "./interDetails.vue?vue&type=template&id=5914dd5d&scoped=true&"
import script from "./interDetails.vue?vue&type=script&lang=js&"
export * from "./interDetails.vue?vue&type=script&lang=js&"
import style0 from "./interDetails.vue?vue&type=style&index=0&id=5914dd5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914dd5d",
  null
  
)

export default component.exports